import MockTranslationsENUS from './translations-en-us';
import MockTranslationsHIIN from './translations-hi-in';

export const getTranslationsBasedOnLanguageCode = (languageCode) => {
  const translations = languageCode === 'hi-IN' ? MockTranslationsHIIN : MockTranslationsENUS;

  return { response: { data: translations, status: 1 } };
};
